import redIcon from './red.svg';
import blueIcon from './blue.svg';
import meterIcon from './meter.svg';
import accessibilityIcon from './accessibility.svg';
import c from './park-type.module.scss';
import classNames from 'classnames';

const map = {
  Red: {
    icon: redIcon,
    text: 'Red',
  },
  Blue: {
    icon: blueIcon,
    text: 'Blue',
  },
  Orange: {
    icon: accessibilityIcon,
    text: 'Accessible',
  },
  Visitor: {
    icon: meterIcon,
    text: 'Meter',
  },
};

const ParkType = ({ type, className, spacesCount, hideText = false }) => {
  const value = map[type];

  if (!value) {
    return null;
  }

  const classes = classNames(c.wrapper, className);
  const spacesText = spacesCount ? ` (${spacesCount} spaces)` : '';

  return (
    <div className={classes}>
      <img src={value.icon} alt="" />
      {!hideText && (
        <span className={c[type]}>
          {value.text}
          {spacesText}
        </span>
      )}
    </div>
  );
};

export default ParkType;
